export default __webpack_public_path__ + "static/media/MandatoryFields.2aed3e41.pdf";